import React from "react";
import { UseFormReturn } from "react-hook-form";

import { 
    Accordion, 
    AccordionDetails, 
    AccordionSummary, 
    Fab, 
    Grid, 
    IconButton, 
    List, 
    ListItem, 
    ListItemIcon, 
    ListItemText, 
    Tooltip, 
    Typography, 
    Stack 
} from "@mui/material";

import { t, Trans } from "@lingui/macro";

import { TitleAndSynopsisDataProps, TitleAndSynopsisDataState } from "./models";

import { selectDescriptionByLanguage } from "utils";

import { 
    ZPlayMultilineTextField, 
    ZPlayFormField, 
    ZPlayAutocomplete
} from "commons/fields";

import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import AddIcon from '@mui/icons-material/Add';
import ClearIcon from '@mui/icons-material/Clear';
import EditIcon from '@mui/icons-material/Edit';
import CircleIcon from '@mui/icons-material/Circle';
import ErrorIcon from '@mui/icons-material/Error';
import { ContentDescription } from "models/content";
import EditTitleAndDescriptionModal from "./edit-title-and-description-modal/edit-title-and-description-modal";


export class TitleAndSynopsisData extends React.Component<TitleAndSynopsisDataProps & UseFormReturn, TitleAndSynopsisDataState>
{
    constructor(props: any) {

        super(props);

        this.state = {
            error: false,
            languageError: false,
            languages: this.props.languageList,
            openEditModal: false,
            editLanguage: null,
            editTilte: "",
            editDescription: ""
        }
    }

    private delete = (language: string) => {

        let newContentTitle = this.props.title.filter(item => item.language !== language);
        let newContentSynopsis = this.props.synopsis.filter(item => item.language !== language);

        this.props.updateTitleAndSynopsis(newContentTitle, newContentSynopsis);
    }

    private edit = (language: string) => {

        let title = this.props.title.find( l => l.language===language)
        let description =  this.props.synopsis.find( l => l.language===language)
        let lan = this.props.languageList.find( l => l.isoCode===language)

        this.setState(() => ({
           editDescription: description!.description,
           editTilte: title!.description,
           editLanguage: lan!,
        }), this.openModal);

    }

    private editCallback = (title: string, description: string) =>{
        let newContentTitle = this.props.title.map((oggetto) => {
            if (oggetto.language === this.state.editLanguage!.isoCode) {
                return { ...oggetto, description: title };
            }
            return oggetto;
        });

        let newContentSynopsis = this.props.synopsis.map((oggetto) => {
            if (oggetto.language === this.state.editLanguage!.isoCode) {
                return { ...oggetto, description: description };
            }
            return oggetto;
        });

        this.props.updateTitleAndSynopsis(newContentTitle, newContentSynopsis);
        this.setState(() => ({
            editDescription: "",
            editTilte: "",
            editLanguage: null
        }));
        this.closeModal()
    }

    private addTitleSynopsis = (): void => {

        this.setState(() => ({
            error: false,
            languageError: false
        }));

        let isoCode = this.props.languageList.find(language => language.id ===  this.props.getValues(`${this.props.name}.titleLanguage`))?.isoCode

        let title: ContentDescription = {
            language: isoCode ? isoCode : "",
            description: this.props.getValues(`${this.props.name}.title`)
        };

        let synopsis: ContentDescription = {
            language: isoCode ? isoCode : "",
            description: this.props.getValues(`${this.props.name}.synopsis`)
        };

        if(title.language!=="" && this.props.title.some(obj => obj.language === title.language)){
            this.setState(() => ({
                languageError: true,
            }));
            return
        }

        if (title.language==="" || !title.description || !synopsis.description) {
            this.setState(() => ({
                error: true,
            }));
            return
        }

        let newContentTitle = this.props.title.concat(title);
        let newContentSynopsis = this.props.synopsis.concat(synopsis);

        this.props.updateTitleAndSynopsis(newContentTitle, newContentSynopsis);
        
        this.props.setValue(`${this.props.name}.title`, "")
        this.props.setValue(`${this.props.name}.synopsis`, "")
    }

    private closeModal = (): void => {
        this.setState(() => ({
            openEditModal: false
        }));
    };

    private openModal = (): void => {
        this.setState(() => ({
                openEditModal: true,
            })
        )
    }


    render() {
        return (
            <>
                <Accordion sx={{ backgroundColor: process.env.REACT_APP_THIRD_COLOR }}>
                    <AccordionSummary
                        expandIcon={<ExpandMoreIcon sx={{ color: "white" }} />}
                        aria-controls="panel1a-content"
                        id="panel1a-header"
                    >
                        <Typography color={process.env.REACT_APP_DEFAULT_TEXT_COLOR}>
                            <Trans id={"tasd-title-synopsis-section"}>Titolo e Sinossi</Trans>
                        </Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                        {this.props.title.length > 0  && <Grid container mb={2}>
                            <Grid item xs={12} md={8} color={process.env.REACT_APP_DEFAULT_TEXT_COLOR}>
                                <List dense>
                                    {this.props.title.map((title, i) =>
                                        <ListItem
                                            key={i}
                                            secondaryAction={
                                            <>
                                                <IconButton edge="end" aria-label="edit" onClick={() => this.edit(title.language)}>
                                                    <EditIcon fontSize="small" sx={{ color: process.env.REACT_APP_DEFAULT_TEXT_COLOR }} />
                                                </IconButton>
                                                <IconButton edge="end" aria-label="delete" onClick={() => this.delete(title.language)}>
                                                    <ClearIcon fontSize="small" sx={{ color: process.env.REACT_APP_DEFAULT_TEXT_COLOR }} />
                                                </IconButton>
                                            </>
                                            }
                                        >
                                            <ListItemIcon sx={{ minWidth: "35px" }}>
                                                <CircleIcon sx={{ width: "10px", height: "10px", color: process.env.REACT_APP_DEFAULT_TEXT_COLOR }} />
                                            </ListItemIcon>
                                            <ListItemText
                                                primary={
                                                    <Stack direction="row" spacing={5}>
                                                        <Typography
                                                            variant="caption"
                                                            maxWidth={250}
                                                            sx={{
                                                                whiteSpace: "nowrap",
                                                                overflow: "hidden",
                                                                textOverflow: "ellipsis",
                                                            }}>
                                                            {title.description}
                                                        </Typography>
                                                        <Typography
                                                            variant="caption"
                                                            maxWidth={400}
                                                            sx={{
                                                                whiteSpace: "nowrap",
                                                                overflow: "hidden",
                                                                textOverflow: "ellipsis",
                                                            }}>
                                                            {selectDescriptionByLanguage(this.props.synopsis, title.language)}
                                                        </Typography>
                                                    </Stack>
                                                }
                                            />
                                        </ListItem>
                                    )}
                                </List>
                            </Grid>
                        </Grid>}

                        <Grid container columnSpacing={3} rowSpacing={1} mb={2}>
                            <Grid item xs={4} mt={1}>
                                <ZPlayAutocomplete
                                    fieldName={`${this.props.name}.titleLanguage`}
                                    label={t({
                                        id: "tasd-title-language",
                                        message: "Lingua"
                                    })}
                                    formState={this.props.formState}
                                    control={this.props.control}
                                    trigger={this.props.trigger}
                                    data={this.state.languages}
                                    disabledOption={this.state.languages.filter(language => {
                                        return this.props.title.some(title => title.language === language.isoCode);
                                    })}/>
                            </Grid>
                            <Grid item xs={8}>
                                <ZPlayFormField
                                    label={t({
                                        id: "tasd-title",
                                        message: "Titolo"
                                    })}
                                    name={`${this.props.name}.title`}
                                    control={this.props.control}
                                    formState={this.props.formState}
                                    trigger={this.props.trigger}
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <ZPlayMultilineTextField
                                    label={t({
                                        id: "tasd-synopsis",
                                        message: "Sinossi"
                                    })}
                                    name={`${this.props.name}.synopsis`}
                                    rows={2}
                                    maxLength={2048}
                                    control={this.props.control}
                                    formState={this.props.formState}
                                    trigger={this.props.trigger}
                                />
                            </Grid>
                        </Grid>

                        {this.state.error && <Stack direction="row" spacing={1} mb={2}>
                            <ErrorIcon fontSize="small" color="error" />
                            <Typography
                                variant={"body2"}
                                color="error">
                                <Trans id={"tasd-title-synopsis-section-error"}>È necessario inserire la lingua, il titolo e la sinossi per poter aggiungere una traduzione.</Trans>
                            </Typography>
                        </Stack>}
                        {this.state.languageError && <Stack direction="row" spacing={1} mb={2}>
                            <ErrorIcon fontSize="small" color="error" />
                            <Typography
                                variant={"body2"}
                                color="error">
                                <Trans id={"tasd-title-synopsis-section-language-error"}>Esiste già un titolo con la lingua selezionata.</Trans>
                            </Typography>
                        </Stack>}

                        <Tooltip title="Aggiungi il titolo e la sinossi" placement="right">
                            <Fab size="small" color="primary" onClick={this.addTitleSynopsis}>
                                <AddIcon />
                            </Fab>
                        </Tooltip>
                    </AccordionDetails>
                </Accordion>
                {this.state.openEditModal &&
                    <EditTitleAndDescriptionModal
                        title={this.state.editTilte}
                        description={this.state.editDescription}
                        language={this.state.editLanguage}
                        closeModal={this.closeModal}
                        editCallback={this.editCallback}
                    />
                }
            </>
        )
    }
}